<template>
  <ol class="promotions-wrapper" v-if="sortedEntryPromotions.length > 0">
    <li v-for="entry in sortedEntryPromotions" :key="entry.id">
      <h3><router-link :to="{ name: 'entry', params: { id: entry.id } }">{{ entry.data.name }}</router-link></h3>
      <entry-promotions :promotions="entry.promotions" :headline-level="4"></entry-promotions>
    </li>
  </ol>
</template>

<script>
  import { mapState } from "vuex";
  import * as moment from "moment";
  import EntryPromotions from "./EntryPromotions";

  export default {
    name: "sk-promotions",
    components: {
      EntryPromotions
    },
    data () {
      return {}
    },
    computed: {
      ...mapState([
        "promotionDays",
        "promotionEntries"
      ]),
      sortedEntryPromotions: function() {
        if (!this.promotionEntries) {
          return [];
        }

        const startLowerBound = moment().startOf("day");
        const endUpperBound = moment().add(this.promotionDays, "days").endOf("day");

        return this.promotionEntries.map(entry => {
          return {
            id: entry.id,
            data: entry.data,
            promotions: entry.data.promotions
              .map(promotion => {
                promotion.start = moment(promotion.start, "YYYY-MM-DDTHH:mm:ss.SSSZZ");
                promotion.end = moment(promotion.end, "YYYY-MM-DDTHH:mm:ss.SSSZZ");

                return promotion;
              })
              .filter(promotion =>
                (promotion.start.isSameOrAfter(startLowerBound) && promotion.start.isSameOrBefore(endUpperBound)) ||
                (promotion.end.isSameOrAfter(startLowerBound) && promotion.end.isSameOrBefore(endUpperBound))
              )
              .sort((a, b) => a.valueOf() - b.valueOf())
          }
        })
          .filter(entry => entry.promotions.length > 0)
          .sort((entryA, entryB) => entryA.promotions[0].start.valueOf() - entryB.promotions[0].start.valueOf())
          .slice(0, 5);
      }
    }
  }
</script>

<style lang="scss">
  .promotions-wrapper {
    display: block;
    margin: 0;
    padding: 0;
    list-style: none;

    h3 {
      margin: 0 0 0.5rem 0;
    }

    & > li {
      display: block;
      padding: 0.75rem 0;

      .entry-promotions {
        margin-bottom: 0;
      }
    }

    & > li + li {
      border-top: 1px solid #d3d3d2;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/StadtKatalogPromotions.vue